export default "__VITE_ASSET__B3$fQTYg__"